import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import ConfigContext from '../../../contexts/ConfigContext';

import Accordion from '../../shared/Accordion';
import AccordionItem from '../../shared/AccordionItem';
import accordionMenuTheme from '../../shared/Accordion-publicMenu.module.postcss';

import { groupedMenu, money } from '../../vendor/truck/profile/profileSummary';

import styles from './TruckMenu.module.postcss';

function TruckMenuItem({ item }) {
  const { imageBase } = useContext(ConfigContext);
  const options = item.options || [];
  const sizes = options.filter((o) => o.kind === 'size');
  const addOns = options.filter((o) => o.kind === 'add_on');

  return (
    <div className={styles.TruckMenuItem}>
      <div className={styles.TruckMenuItem_content}>
        <div className='u-strong'>
          {item.name}
          { item.sold_out && <span className={styles.TruckMenuItem_soldOut}>Sold out</span> }
        </div>
        <p className='u-lightGrey u-mb05 u-mt05'>{item.description}</p>
        <div className='u-strong'>{money(item.price)}</div>
        { sizes.length > 0 &&
          <div className={styles.TruckMenuItem_options}>
            { sizes.map((o) => `${o.name} ${money(o.price)}`).join(' · ') }
          </div>
        }
        { addOns.length > 0 &&
          <div className={styles.TruckMenuItem_options}>
            { addOns.map((o) => `+ ${o.name} ${money(o.price)}`).join(' · ') }
          </div>
        }
      </div>
      { item.photo &&
        <img
          className={styles.TruckMenuItem_photo}
          src={`${imageBase}/${item.photo}`}
          alt={item.name}
          loading='lazy'
        />
      }
    </div>
  );
}

// Sold-out items stay on the menu rather than vanishing, so a customer still
// sees the range of what the truck sells.
function TruckMenu({ truck }) {
  const groups = groupedMenu(truck).filter(
    (group) => !group.hidden && group.items.length > 0
  );

  return (
    <Accordion theme={accordionMenuTheme}>
      { groups.map((group) => (
        <AccordionItem title={group.name} key={group.id || group.name}>
          { group.items.map((item) => <TruckMenuItem item={item} key={item.id} />) }
        </AccordionItem>
      )) }
    </Accordion>
  );
}

TruckMenu.propTypes = {
  truck: PropTypes.object.isRequired,
};

export default TruckMenu;
